GP.GPMod('Util', function(self) {
    var debugging = false;

    var log_level = 1; // info >= 3, log >= 2, warn >= 1 error has no check

    var _conf = {
        placeholder_pic_regex: /(discreet|nopic|nude|review)/,
        http_scheme_regex: /^http:/i,
        url_scheme_regex: /^[[:alpha:]]+:\/\//i,  // match any scheme/protocol including the "://" part
        // url_scheme_regex: /^https?:/i,         // match 'http:' or 'https:'
        // url_scheme_regex: /^(http:|https:)/i,  // match 'http:' or 'https:'
        carousel_pic_re: /-(M|L)(-[0-9])?\.jpg/g,
        m_or_l_re: /(M|L)/g,
        // chrome_60_regex: /Chrome\/60\./,
        chrome_60_regex: /Chrome\/6[0-9]{1}\./,
        limited_growls_regex: /(smokeandpoke|sexygamerz|bbwz|bootycallz).com/,
        nanoScroller: {
            preventPageScrolling: true,
            iOSNativeScrolling:   true
        },
        alert_duration: 2000,
        timeago: {
            prefixAgo: null,
            prefixFromNow: null,
            suffixAgo: null,
            suffixFromNow: null,
            seconds: "now",
            minute: "%dm",
            minutes: "%dm",
            hour: "%dh",
            hours: "%dh",
            day: "%dd",
            days: "%dd",
            month: "4w",
            months: function(value) {
                return ((value * 4) + "w");
            },
            year: "%dy",
            years: "%dy"
        }
    };

    // functions that were formally referenced via GP.Util
    // now it's just GP.Util.(log|warn|check_nested...)

    // allow changing debug logging on the fly
    // i.e. GP.Util.debug_logging(true, 3) to set debugging to true and log levels of info, log and warn
    self.debug_logging = function(flag, level) {
        if (typeof flag != 'undefined') {
            debugging = !!flag;
        }
        if (typeof level != 'undefined') {
            level = parseInt(level, 10);

            // _.isFinite() returns false for NaN and other crap, and true for a valid number/result from parseInt()
            if (_.isFinite(level) && level >= 1 && level <= 3) {
                log_level = level;
            }
        }
       console.log("debug logging set to: %o and level: %d ", debugging, log_level);
    };

    // wrapper for console.info
    self.info = function() {
        var global_debug = !!window._gp_global_debug;

        if (global_debug || (debugging === true && log_level >= 3)) {
            if (typeof console !== 'undefined' && typeof console.info === 'function') {
               console.info.apply(console, arguments);
            }
        }
    };

    // wrapper for console.log
    self.log = function() {
        var global_debug = !!window._gp_global_debug;

        if (global_debug || (debugging === true && log_level >= 2)) {
            if (typeof console !== 'undefined' && typeof console.log === 'function') {
               console.log.apply(console, arguments);
            }
        }
    };

    // wrapper for console.log without checking debugging flag/log_level (i.e. calls console.log if available)
    self.log_console = function() {
        if (typeof console !== 'undefined' && typeof console.log === 'function') {
           console.log.apply(console, arguments);
        }
    };

    // wrapper for console.warn
    self.warn = function() {
        var global_debug = !!window._gp_global_debug;

        if (global_debug || (debugging === true && log_level >= 1)) {
            if (typeof console !== 'undefined' && typeof console.warn === 'function') {
               console.warn.apply(console, arguments);
            }
        }
    };

    // wrapper for console.error
    self.error = function() {
        var global_debug = !!window._gp_global_debug;

        if (global_debug || debugging === true) {
            if (typeof console !== 'undefined' && typeof console.error === 'function') {
                console.error.apply(console, arguments);
            }
        }
    };

    // wrapper for console.trace
    self.trace = function() {
        var global_debug = !!window._gp_global_debug;

        if (global_debug || (debugging === true && log_level >= 3)) {
            if (typeof console !== 'undefined' && typeof console.trace === 'function') {
               console.trace.apply(console, arguments);
            }
        }
    };

    // return new object with current values of the obj passed
    // free of refs from original obj (i.e. snapshot of object as it is now)
    self.obj_snapshot = function(obj_param) {
        return $.extend(true, {}, obj_param);
    };


    // wrapper for our console.log wrapper, but will capture object
    // prop/vals as they were at call time vs a normal console call (e.g. `console.log('msg', obj);`)
    // which would have `obj` called by reference and therefore values are not guaranteed
    // to be consistent with the values as they were at call time vs the values
    // once they are inspected in the console
    self.log_obj = function(...args) {
        var global_debug = !!window._gp_global_debug;

        if (global_debug || (debugging === true && log_level >= 2)) {
            var new_args = [];

            for (var i in args) {
                if (typeof args[i] === 'object') {
                    new_args.push(self.obj_snapshot(args[i]));
                } else {
                    new_args.push(args[i]);
                }
            }

            if (new_args.length) {
                self.log.apply(null, new_args);
            }
        }
    };


    self.dev_test = function() {
        if (_dev_server === true || (String(window.location.hostname).indexOf('dev.') >= 0)) {
            return true;
        }
        return false;
    };

    self.parse_json = function(json_string) {
        // check the input type and parse if it's a string, return if it's an object already
        if ($.type(json_string) === 'object') {
            return json_string;
        } else {
            try {
                return $.parseJSON(json_string);
            } catch (ex) {
                self.warn("parse_json exception caught for json_string: ", json_string);
                self.warn("parse_json exception: ", ex);
            }
        }
    };

    self.set_cookie = function(name, value, expire_days) {
        var cookie_obj = {
            expires: expire_days,
            path: '/'
        };
        if (typeof _cookie_domain != 'undefined' && _cookie_domain) {
            cookie_obj.domain = _cookie_domain;
        }
        $.cookie(name, value, cookie_obj);
    };

    // util function to wrap cometd channel subscription handler functions and check the data passed into it
    // all cometd channel messages come through as message.data, so we can just check that in one place
    // also can check another object property with check_prop.
    // if present will check message.data[check_prop] (ex: if check_prop is "users", it would check message.data.users)
    self.handler_wrap = function (func, check_prop) {
        return function () {
            var args = Array.prototype.slice.call(arguments);

            if (typeof args != 'undefined' && args && args[0] && args[0].data) {
                if (typeof check_prop != 'undefined' && check_prop) {
                    if (args[0].data[check_prop]) {
                        return func.apply(this, args);
                    }
                } else {
                    return func.apply(this, args);
                }
            } else {
                self.warn('handler_wrap logic failed!!');
            }
        };
    };

    self.check_obj = function(obj) {
        if (typeof obj != 'undefined') {
            if (obj !== null && obj !== '' && obj !== 0) {
                return true;
            }
        }
        return false;
    };

    self.check_array = function(param) {
        if (typeof param != 'undefined' && param !== null) {
            if (_.isArray(param) && param.length > 0) {
                return true;
            }
        }
        return false;
    };

    self.check_callable = function(obj) {
        if (typeof obj !== 'undefined') {
            if (typeof obj === 'function') {
                return true;
            }
        }
        return false;
    };

    // pass a var (obj or just a duid) and array of blocked users, and return true if they're blocked
    self.is_user_blocked = function(json, blocked) {
        var found      = false,
            check_duid = 0;

        // if a user has no blocked users to check against (or the blocked param isn't a legit array), then don't bother
        if (self.check_array(blocked) === false) {
            return false;
        }

        // check what kind of var json is (either an object or just a duid)
        // and extract the duid we want to test against blocked users array
        if (typeof json != 'undefined' && json) {
            if (typeof json == 'object') {
                if (json.hasOwnProperty('duid') && json.duid) {
                    check_duid = parseInt(json.duid, 10) || 0;
                    // self.log('is_user_blocked check_duid (via json.duid): ', check_duid);

                } else if (json.hasOwnProperty('users') && json.users.length) { // new_message growls etc...
                    var tmp_user = json.users[0];
                    check_duid = parseInt(tmp_user.duid, 10) || 0;
                    // self.log('is_user_blocked check_duid (via json.users[0].duid): ', check_duid);

                } else if (json.hasOwnProperty('user') && json.user) { // activity from send_rt_activity
                    if (json.user.hasOwnProperty('duid') && json.user.duid) {
                        check_duid = parseInt(json.user.duid, 10) || 0;
                        // self.log('is_user_blocked check_duid (via json.user.duid): ', check_duid);
                    }
                }
            } else if (typeof json == 'number' || typeof json == 'string') {
                check_duid = parseInt(json, 10) || 0;
                // self.log('is_user_blocked check_duid (via json was the duid): ', check_duid);
            }
        }

        // test the check_duid we found against the blocked users array
        if (check_duid) {
            $.each(blocked, function(i, user) {
                if (check_duid == parseInt(user.duid, 10)) {
                    found = true;
                    self.log('Util.is_user_blocked found and BLOCKING duid: ', check_duid);

                    return false; // this will break out of jQuery's .each() like break would for a regular loop;
                }
            });
        }

        return found;
    };

    self.in_array = function(needle, haystack) {
        var length = haystack.length;
        for (var i = 0; i < length; i++) {
            if (haystack[i] == needle) {
                return true;
            }
        }
        return false;
    };

    self.is_object = function(variable) {
        return variable !== null && typeof variable === 'object';
    };

    // can be an image, revealing placeholder or nopic
    self.select_rated_image = function(obj, rating, max_rating)  {

        //console.log("DUID:" + obj.duid + " RATING:" + rating + " MAX:" + max_rating);

        var nopic = 'https://cachemd.cdnhost2000xl.com/images/thumbs/nopic-WOMAN-S.jpg';

        if (!obj.hasOwnProperty('max_content_' + max_rating.toLowerCase() + '_pic')) {
//            console.log('select_rated_image missing required rating pic: ' + rating);
            return nopic;
        }

        // replace nude placeholder with nopic
        if (/nude/.test(obj['max_content_' + max_rating.toLowerCase() + '_pic'])) {
            return nopic;
        }

        return obj['max_content_' + rating + '_pic'];
    };

    // to check if obj.level1.level2.level3 exists: check_nested(obj, 'level1.level2.level3')
    self.check_nested = function(obj, property_string) {
        // the in operator requires an object: "var in othervar"
        if (!self.is_object(obj)) {
            return false;
        }
        var array_to_check = property_string.split('.');

        for (var i = 0; i < array_to_check.length; i++) {
            if (!(array_to_check[i] in obj)) {
              return false;
            }
            obj = obj[array_to_check[i]];
        }
        return true;
    };

    self.check_ios = function() {
        var userAgent = window.navigator.userAgent.toLowerCase();
        var re = /iphone|ipod|ipad/;
        return re.test(userAgent);
    };

    self.check_safari = function() {
        var userAgent = window.navigator.userAgent.toLowerCase();
        var re = /safari/;
        return re.test(userAgent);
    };

    self.check_chrome_60 = function() {
        var ua = window.navigator.userAgent;
        return _conf.chrome_60_regex.test(ua);
    };

    self.test_https = function() {
        var protocol = window.location.protocol;
        return (protocol == 'https:');
    };

    self.is_mobile = function() {
        return (MoshPit.get_size() === 'mobile' || _is_mobile) ? true : false;
    };

    self.check_placeholder_pic = function(pic_url) {
        return _conf.placeholder_pic_regex.test(pic_url);
    };

    // strip the "http:" scheme from a url string (i.e. "http://www.google.com" to "//www.google.com")
    self.strip_http_scheme = function(url) {
        return (url || '').replace(_conf.http_scheme_regex, '');
    };
    // strip the url scheme/protocol
    self.strip_url_scheme = function(url) {
        return (url || '').replace(_conf.url_scheme_regex, '//');
    };

    // ensure activity carousel pic url is of the small "S" variety
    self.parse_carousel_pic = function(url) {
        return (self.strip_http_scheme(url) || '').replace(_conf.carousel_pic_re, function (match, offset, string) {
            return match.replace(_conf.m_or_l_re, 'S');
        });
    };

    // test via regex if the domain/host is smokeandpoke, sexygamerz, bbwz or bootycallz
    self.check_limited_growls_host = function() {
        return _conf.limited_growls_regex.test(window.location.host);
    };

    // clientside implementation of clean_url functionality
    self.clean_url = function(path, params) {
        params = params || {};

        var url_params = [];
        var mapping = {
            from:/(?:a=(\w+).(\w+))/g,
            to:"members/$1/$2"
        };

        // if params are a string, convert to obj
        if (typeof params == 'string') {
            var str_params = params.split('&');
            params = {};
            for (var i=0; i<str_params.length; i++) {
                var param = str_params[i];
                if (param.length) {
                    param = param.split('=');
                    params[param[0]] = param[1];
                }
            }
        }

        if (path.indexOf('?') != -1) {
            if (path.search(mapping.from) != -1) {
            // old url, handle remapping
                var parts = mapping.from.exec(path);
                if (parts.length >= 3) {
                    path = path.replace(parts[0],''); // wipe out a=$1.$2 from path url
                    path = path.split('?');
                    path[0] = mapping.to.replace('$1',parts[1]).replace('$2',parts[2]);
                    path = path.join('?');
                }
            }
            // there were params in the old path, move them into params obj
            path = path.split('?');
            if (path.length == 2) {
                var path_params = path[1].split('&');
                for (var ii=0; ii<path_params.length; ii++) {
                    var param2 = path_params[ii];
                    if (param2.length) {
                        param2 = param2.split('=');
                        params[param2[0]] = param2[1];
                    }
                }
            }
            path = path[0];
        }

        for (var param_name in params) {
            if (params.hasOwnProperty(param_name)) {
                url_params.push(param_name+'='+encodeURIComponent(params[param_name]));
            }
        }

        if (url_params.length) {
            url_params = '?'+url_params.join('&');
        } else {
            url_params = '';
        }

        // remove trailing/ending /
        path = path.split('/');
        if (path[0].length === 0) {
            path.shift();
        }
        if (path[path.length-1].length === 0) {
            path.pop();
        }
        path = path.join('/');

        return '//'+window.location.host+'/'+path+'/'+url_params;
    };

    self.count_chars = function(text_input, char_display, max_chars) {
        var length     = text_input.val().length,
            max_length = max_chars || content_post_max_chars,
            chars_left = max_length - length;

        if (chars_left <= 0) {
            var str = $.trim(text_input.val());
            str = str.slice(0, max_length);
            text_input.val(str);
            chars_left = 0;
        }
        char_display.text(chars_left);
    };

    // cross browser get document height
    self.get_doc_height = function() {
        return Math.max(
            $(document).height(),
            $(window).height(),
            /* For opera: */
            document.documentElement.clientHeight
        );
    };

    self.k_formatter = function(num) {
        if (num <= 0) {
            return '';
        }
        return num > 999 ? (num/1000).toFixed(1) + 'k' : num;
    };

    self.check_location = function(location) {
        var _current_url = (window.location.pathname + window.location.search).toLowerCase();
        return (_current_url.indexOf(location) !== -1);
    };

    self.check_media_type = function(file_input) {
        file_input = file_input.files[0];
        var image_types = /^image\/(gif|jpe?g|png|bmp)$/i,
             // This is for IE<10 because file mimetypes isn't defined in the file data
            image_names =  /\.(gif|jpe?g|png|bmp)$/i,
            video_types = /^video\/(mp4|m4v|wmv|avi|mov|asf|quicktime|divx|ddat|webm|3gpp|x-flv|ogg|mpeg|mpg|flv)$/i,
            video_names =  /\.(mp4|m4v|wmv|avi|mov|asf|ddat|webm|flv|3gp|ogv|mpeg|mpg|mpeg4|mp4v|divx|h264)$/i,
            _media_type = null;

        if (typeof file_input !== 'undefined') {
            if ((typeof file_input.type !== 'undefined' && image_types.test(file_input.type)) ||
                (typeof file_input.name !== 'undefined' && image_names.test(file_input.name))) {
                _media_type = 'image';
            } else if ((typeof file_input.type !== 'undefined' && video_types.test(file_input.type)) ||
                (typeof file_input.name !== 'undefined' && video_names.test(file_input.name))) {
                _media_type = 'video';
            }
        }

        return _media_type;
    };

    self.format_story = function(story, max_chars) {
        var _max_story_chars = max_chars || 400;

        if (story.length <= _max_story_chars) {
            return story;
        }

        var read_more_link = "<span class='text-link'>read more</span>";
        return story.slice(0, _max_story_chars) + '...' + read_more_link;
    };

    // return the difference in days if given a timestamp in unix time
    self.day_diff = function(timestamp) {
        let time = new Date(timestamp * 1000);
        let curr_time = new Date();
        let time_diff = Math.abs(curr_time - time);
        return Math.ceil(time_diff / (1000 * 3600 * 24));
    };

    var timers = {
        active: {}, // list of active timers

        // set
        // @arguments[0] "exec" (function) : function to execute when timer is triggered
        // @arguments[1] "milliseconds" (integer) : milliseonds to wait before firing
        // @arguments[2] "name" (string) : name of the timer to store in active
        // @arguments[3] "recurring" (Boolean) : if true, timer will fire until cleared
        // @arguments[4] "recurring_call_immediately" (Boolean) : if true, timer will fire until cleared
        set: function(/*exec, milliseconds, [name], [recurring]*/) {
            if (arguments.length <= 1) {
                return; // not enough information
            }

            var timer_func = arguments[0];
            var timer_time = arguments[1];

            if (arguments.length === 2) {
                // set unamed timer
                setTimeout(timer_func, timer_time);
            } else if (arguments.length >= 3){
                // named timer, possibly recurring.
                var timer_name = arguments[2];

                // if timer exists, remove it before we recreate it
                if (typeof timers.active[timer_name] !== 'undefined') {
                    timers.clear(timer_name);
                }

                var is_recurring     = (typeof arguments[3] !== 'undefined' && arguments[3] === true) ? true : false;
                var call_immediately = (typeof arguments[4] !== 'undefined' && arguments[4] === true) ? true : false;

                timers.active[timer_name] = {
                    id:0,
                    name: timer_name,
                    func: timer_func,
                    recurring: is_recurring
                };

                // recurring timers should use setInterval
                if (is_recurring === true) {
                    timers.active[timer_name].id = setInterval(function(){
                        timers.trigger(timer_name);
                    }, timer_time);

                    // call this recurring timer right away if flag is set
                    // setInterval waits for the interval specified before fist call will fire
                    if (call_immediately === true) {
                        timers.trigger(timer_name);
                    }
                } else {
                    timers.active[timer_name].id = setTimeout(function(){
                        timers.trigger(timer_name);
                    }, timer_time);
                }
            }
        },
        // trigger a timer event
        trigger: function(timer_name) {
            var timer_record = timers.active[timer_name];
            if (typeof timer_record !== 'undefined') {
                timer_record.func(); // exec
                if (timer_record.recurring === false) {
                    // if this timer wasn't set to recurring, clear it's record
                    timers.clear(timer_name);
                }
            }
        },
        // clears a timer entry and execution
        clear: function(timer_name) {
            var timer_record = timers.active[timer_name];
            if (typeof timer_record !== 'undefined') {
                if (timer_record.recurring === true) {
                    clearInterval(timer_record.id);
                } else {
                   clearTimeout(timer_record.id);
                }
                delete timers.active[timer_name];
            }
        },
        // clears all timers
        clear_all: function() {
            for (var timer_name in timers.active) {
                if (timers.active.hasOwnProperty(timer_name)) {
                    timers.clear(timer_name);
                }
            }
        },
        // clears all timers with a namespace/prefix.
        // if namespace is 'im_', it will clear all timers that start with 'im_'
        clear_all_ns: function(namespace) {
            for (var timer_name in timers.active) {
                if (timer_name.indexOf(namespace) >= 0) {
                    timers.clear(timer_name);
                }
            }
        },
        // check if a named timer exists
        exists: function(timer_name) {
            if (typeof timers.active[timer_name] !== 'undefined') {
                return true;
            } else {
                return false;
            }
        }
    };


    var gui = {
        toggle_loading_spinner: function(show, el, size) {
            var selector = "#" + el;
            var spinner_size = self.check_obj(size) ? size : 'small';

            if (show) {
                // if we are showing the loading_spinner, make sure no results is hidden
                gui.toggle_no_results(false, el);
                $(selector + " .loading").addClass('show').children(".spinner-container").spin(spinner_size);
            } else {
                $(selector + " .loading").removeClass('show').children(".spinner-container").spin(false);
            }
        },
        toggle_no_results: function(show, el) {
            var selector = "#" + el;

            if (show) {
                $(selector + " .no-results").addClass('show');
            } else {
                $(selector + " .no-results").removeClass('show');
            }
        },
        show_alert: function($wrapper, $alert) {
            $wrapper.prepend($alert);

            timers.set(function() {
                $alert.fadeOut("slow", function() {
                    $alert.remove();
                });
            }, _conf.alert_duration);
        }
    };


    this.addInitializer(function(a) {
        // make available throughout the GP app via GP.Util, or self.app.Util
        self.timers  = timers;
        self.gui     = gui;
        self.configs = _conf;

        // test for dev enviornment and set debugging var
        debugging = (self.dev_test()) ? true : false;

    });

    self.get_caller = function() {
        const err = new Error();
        const stack = err.stack.split('\n');
        return stack[3].trim();
    };
});
